// bomMappingService.js
import axiosClient from "../../../../api/axiosClient";

// ---------------------------------------------------------
// PREVIEW MANUFACTURER MAPPING
// ---------------------------------------------------------
export const previewManufacturerMapping = async ({
  category,
  manufacturer,
  bom_ids
}) => {

  const params = new URLSearchParams();

  params.append("category", category);
  params.append("manufacturer", manufacturer);

  bom_ids.forEach(id => {
    params.append("bom_ids", id);
  });

  const response = await axiosClient.get(
    `/api/ipe/boms/manufacturer-mapping?${params.toString()}`
  );

  return response.data;
};


// ---------------------------------------------------------
// APPLY MANUFACTURER MAPPING
// ---------------------------------------------------------
export const applyManufacturerMapping = async ({
  category,
  manufacturer,
  bom_ids,
  manual_mappings = {} // ✅ NEW (optional)
}) => {

  const payload = {
    category,
    manufacturer,
    bom_ids
  };

  // ✅ ADD ONLY IF PRESENT (SAFE)
  if (manual_mappings && Object.keys(manual_mappings).length > 0) {
    payload.manual_mappings = manual_mappings;
  }

  const response = await axiosClient.post(
    `/api/ipe/boms/apply-manufacturer-mapping`,
    payload
  );

  return response.data;
};